import { IconName } from '@forto-dev/phoenix-ui-core/common'

import { BookingDTOTransportMode } from '@/clients/booking'
import { getHouseShipmentByCodeWithoutDeserialization, TransportMode, TransportType } from '@/features/shipments'

import { retry } from './networking/retry'

const iconMap: Record<TransportMode | BookingDTOTransportMode, IconName> = {
  sea: 'Shipment',
  air: 'Plane',
  seaAir: 'Transhipment',
  rail: 'Railway',
  road: 'Truck',
}

export const getIconForTransportMode = (carriageMode: TransportMode | BookingDTOTransportMode): IconName => {
  return iconMap[carriageMode]
}

export const getLabelForTransportMode = (mode: TransportMode): string => {
  switch (mode) {
    case 'sea':
      return 'Sea'
    case 'air':
      return 'Air'
    case 'seaAir':
      return 'Sea-Air'
    case 'rail':
      return 'Railway'
  }
}

export const getIconForTransportType = (mode: TransportType): IconName => {
  switch (mode) {
    case 'lcl':
      return 'Lcl'
    case 'fcl':
      return 'Fcl'
  }
}

export const waitForShipmentToExist = async (shipmentId: string, maxAttempts = 10, delay = 1000): Promise<boolean> => {
  const getShipment = () =>
    getHouseShipmentByCodeWithoutDeserialization(shipmentId, {
      // Suppress error logging: a 404 here is expected while the shipment propagates.
      errorLoggingHandledUpstream: true,
    })
  try {
    await retry(getShipment, maxAttempts, delay)
    return true
  } catch {
    return false
  }
}
